import { NgModule } from '@angular/core';
import { FormModule } from 'lib/ui/form/form.module.js';
import { GenAiModule } from 'lib/ui/genai/genai.module.js';
import { CoreModule } from 'src/app/core/core.module.js';
import { AiChatComponent } from './ai.chat.component.js';
import { BroadcastChatComponent } from './broadcast-chat.component.js';
import { ChatConversationComponent } from './chat-conversation.component.js';
import { ChatComponent } from './chat.component.js';
import { HelpdeskConversationComponent } from './helpdesk-conversation.component.js';
import { HelpdeskListComponent } from './helpdesk-list.component.js';

@NgModule({
	imports: [CoreModule, FormModule, GenAiModule],
	declarations: [
		ChatComponent,
		ChatConversationComponent,
		HelpdeskConversationComponent,
		HelpdeskListComponent,
		AiChatComponent,
		BroadcastChatComponent
	],
	exports: [
		ChatComponent,
		ChatConversationComponent,
		HelpdeskConversationComponent,
		HelpdeskListComponent,
		AiChatComponent,
		BroadcastChatComponent
	]
})
export class ChatModule {}
